"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _element = require("@wordpress/element");

var _components = require("@wordpress/components");

/**
 * WordPress dependencies
 */
const EmbedLoading = () => (0, _element.createElement)("div", {
  className: "wp-block-embed is-loading"
}, (0, _element.createElement)(_components.Spinner, null));

var _default = EmbedLoading;
exports.default = _default;
//# sourceMappingURL=embed-loading.js.map